<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Branch Name</th>
          <th>Branch Address</th>
          <th>Branch ID</th>
          <th>Branch Email</th>
          <th>Branch Contact No</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in branches" :key="i">
          <td> {{ item.name }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.contact_no }}</td>
          <td>{{ item.status }}</td>
          <td style="cursor: pointer">
            <span @click="goToView(item.id)">View</span>
            /
            <span @click="goToEdit({...item})">Edit</span>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!branches.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'branchListTable',
  props: {
    branches: []
  },
  methods: {

    goToEdit(data) {
      this.$emit('onEdit', data);
    },

    goToView(id) {
      // TODO,
    }
  }
}
</script>
